// eslint-disable-next-line import/named
import Markdown, { Components } from 'react-markdown'
import { Link, List } from '@mui/material'

interface PixyMarkdownProps {
  children: string
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  components?: Components
}

/**
 * A reusable component for rendering markdown content consistently across the application
 * with support for links, code blocks, and lists.
 */
export default function PixyMarkdown({
  children,
  components = {},
}: PixyMarkdownProps) {
  return (
    <Markdown
      components={{
        a: ({ children, href }) => (
          <Link
            color="primary"
            href={href}
            target="_blank"
            onClick={(e) => e.stopPropagation()}
            underline="none"
            noWrap
            variant="inherit"
          >
            {children}
          </Link>
        ),
        code: ({ children }) => (
          <code
            style={{
              display: 'block',
              whiteSpace: 'pre-wrap',
              overflowWrap: 'break-word',
            }}
          >
            {children}
          </code>
        ),
        ul: ({ children }) => (
          <List
            dense
            disablePadding
            sx={{
              listStyleType: 'disc',
              pl: 2,
              fontSize: 'inherit',
              a: {
                display: 'block',
              },
            }}
          >
            {children}
          </List>
        ),
        ...components,
      }}
    >
      {children}
    </Markdown>
  )
}
